<nav mat-tab-nav-bar
  [class]="inputClass"
  [disablePagination]="true"
  [tabPanel]="tabPanel">

  <swiper-container #swiper class="navigation-carousel" slides-per-view="auto" free-mode="true">
    @for (link of links; track link; let i = $index) {
      <swiper-slide>
        @if (!link.roles || currentUser.hasRoles(link.roles)) {
          <a (click)="slideToActiveTab(i)"
            tourAnchor="tab{{ link.label }}"
            mat-tab-link
            routerLinkActive
            #rla="routerLinkActive"
            (isActiveChange)="slideToActiveTab(i)"
            [attr.id]="link.id"
            [active]="rla.isActive"
            [routerLink]="[link.url]">
            {{link.label}}
          </a>
        }
      </swiper-slide>
    }
  </swiper-container>
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
